export const techStack = [
  {
    id: 1,
    name: 'HTML',
  },
  {
    id: 2,
    name: 'CSS',
  },
  {
    id: 3,
    name: 'Bootstrap',
  },
  {
    id: 4,
    name: 'Tailwind',
  },
  {
    id: 5,
    name: 'JavaScript',
  },
  {
    id: 6,
    name: 'React',
  },
  {
    id: 7,
    name: 'Angular',
  },
  {
    id: 8,
    name: 'Vue',
  },
  {
    id: 9,
    name: 'Svelte',
  },
  {
    id: 10,
    name: 'PHP',
  },
  {
    id: 11,
    name: 'C',
  },
  {
    id: 12,
    name: 'C#',
  },
  {
    id: 13,
    name: 'C++',
  },
  {
    id: 14,
    name: 'Java',
  },
  /* css: 'CSS',
  bootstrap: 'Bootstrap',
  tailwind: 'Tailwind',
  javascript: 'JavaScript',
  react: 'React',
  angular: 'Angular',
  vue: 'Vue',
  svelte: 'Svelte',
  php: 'PHP',
  c: 'C',
  cSharp: 'C#',
  cPlusPlus: 'C++',
  java: 'Java', */
];
